import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import RichTextEditor from 'designer/component/element/RichText/Editor'
import RichTextPreview from 'designer/component/element/RichText/Preview'
import RichTextPattern from 'designer/component/element/RichText/Pattern'

export const RichTextSystem = (props) => (
  <DragElementWrapper {...props}>
    {props.uischema.readonly && <RichTextPattern {...props} />}
    <RichTextEditor {...props} />
    <div
      style={{ border: '1px dashed' }}
      className={`position-relative p-1 m-1 rounded border-secondary`}
    >
      <p className="px-2 pt-2 pb-0">
        ตัวอย่าง Rich Text ในรูปแบบแสดงผล
        <span className="text-danger"> *ส่วนนี้จะไม่แสดงบน display*</span>
      </p>
      <hr />
      <div className="px-2">
        <RichTextPreview {...props} />
      </div>
    </div>
  </DragElementWrapper>
)

export const RichTextDisplay = (props) => (
  <ElementWrapper {...props}>
    {props.uischema.readonly ? (
      <RichTextPreview {...props} />
    ) : (
      <>
        {props.uischema.readonly && <RichTextPattern {...props} />}
        <RichTextEditor {...props} />
      </>
    )}
  </ElementWrapper>
)

export const richTextTester = rankWith(1000, scopeEndsWith('richtext'))
